import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { getAllCountries } from "countries-and-timezones";
import { ComponentProps, useMemo } from "react";
import FormInputContainer from "./form-input-container";

const optionEntries = Object.entries(getAllCountries());

const optionsMap = optionEntries.reduce(
  (acc, [iso, country]) => {
    acc[iso] = { name: country.name, code: iso };
    return acc;
  },
  {} as { [key: string]: { name: string; code: string } },
);

type FormCountrySelectorProps = Omit<
  ComponentProps<typeof Select>,
  "value" | "onValueChange"
> & {
  label: string;
  description?: string;
  value: { name: string; code: string };
  onValueChange: (value: { name: string; code: string }) => void;
};

export default function FormCountrySelector({
  label,
  description,
  value = { name: "France", code: "FR" },
  onValueChange,
  ...props
}: FormCountrySelectorProps) {
  const options = useMemo(
    () =>
      optionEntries.map(([iso, country]) => {
        return (
          <SelectItem key={iso} value={iso}>
            {country.name}
          </SelectItem>
        );
      }),
    [],
  );

  return (
    <Select
      value={value.code}
      onValueChange={(v) => {
        onValueChange(optionsMap[v]);
      }}
      {...props}
    >
      <FormInputContainer label={label} description={description}>
        <SelectTrigger>
          <SelectValue placeholder="Select country" />
        </SelectTrigger>
      </FormInputContainer>
      <SelectContent>{options}</SelectContent>
    </Select>
  );
}
